import client from './client';

// Function to fetch all pay periods
export const fetchPayPeriods = async () => {
    try {
      // Make an API request to fetch pay periods
      const response = await client.get('/admin/payPeriods');
      
      // Return the data containing the pay periods
      return response.data;
    } catch (error) {
      // Log any errors encountered while fetching pay periods
      console.error("Error fetching pay periods:", error);
      
      // Throw a new error to indicate failure in fetching pay periods
      throw new Error("Failed to fetch pay periods");
    }
};

// Function to get the count of timesheets for a specific pay period and supervisor
export const getTimesheetCounts = async (payPeriodID: number, supervisorID: number) => {
    try {
      // Make an API request to get timesheet counts based on pay period and supervisor ID
      const response = await client.get('/admin/timesheets/count', {
        params: {
          payPeriodID: payPeriodID,  // Pass the pay period ID as a query parameter
          supervisorID: supervisorID,  // Pass the supervisor ID as a query parameter
        }
      });

      // Return the data containing the timesheet counts
      return response.data;
    } catch (error) {
      // Log any errors encountered while fetching timesheet counts
      console.error("Error fetching timesheet counts:", error);
      
      // Throw a new error to indicate failure in fetching timesheet counts
      throw new Error("Failed to fetch timesheet counts");
    }
};
